'use strict'

import css from './container-stock.styles.scss'
import template from './container-stock.template.pug'

class Controller {
  constructor($mdDialog, $mdMedia) {
    'ngInject'
    Object.assign(this, { $mdDialog, $mdMedia })
    this.loadInventories()
    this.loading = true
  }

  loadInventories() {
    this.customer.getTasksiteInventories(this.tasksite.code).then((inventories) => {
      this.loading = false
      this.inventories = inventories
    })
  }

  cancel() {
    this.$mdDialog.cancel()
  }
}

export const containerStockComponent = {
  controller: Controller,
  controllerAs: '$ctrl',
  clickOutsideToClose: true,
  escapeToClose: true,
  template: template({ css }),
  fullscreen: false,
  bindToController: true,
}

export const containerStockConfig = ($mdDialogProvider) => {
  'ngInject'

  $mdDialogProvider.addPreset('containerStockDialog', {
    options: () => {
      return containerStockComponent
    },
  })
}



// WEBPACK FOOTER //
// ./app/orders/containers/container-stock/container-stock.component.js